import React, { useContext, useEffect, useState } from "react";
import { UserContext, AlertContext } from "../context/MainContext";
import { transaction } from "../actions/transaction";
import Promote from "../components/Promote";
import UploadWidget from "../components/UploadWidget";
import UploadWidgetEdit from "../components/UploadWidgetEdit";
import UploadAdvertisement from "../components/UploadAdvertisement";
import { AiFillCloseCircle } from "react-icons/ai";
import { adverisementRequest } from "../actions/advertisementRequest";
import ReportModal from "../components/ReportModal";

const Store = () => {
  const { user, setUser } = useContext(UserContext);
  const { setAlert } = useContext(AlertContext);
  const [option, setOption] = useState(null);
  const [value, setValue] = useState(null);
  const [advertisement, setAdvertisement] = useState(null);
  const [modal, setModal] = useState(null);
  const [uploadedItems, setUploadedItems] = useState([]);
  const [promotion, setPromotion] = useState(null);
  const [reportModalOpen, setReportModalOpen] = useState(false);

  const purchasePromotion = () => {
    adverisementRequest(
      user.user_id,
      `/user/${user?.user_id}`,
      null,
      user.email_address,
      "Profile",
    );
  };
  const handleTransaction = async () => {
    const numValue = Number(value);
    if (!value || isNaN(numValue) || numValue <= 0) {
      setAlert([
        "Invalid Amount",
        "Please enter a valid number of keys",
        "failed",
      ]);
      return;
    }
    if (
      (option === "Sell" || option === "Stake") &&
      numValue > (user.key_balance || 0)
    ) {
      setAlert([
        "Insufficient Keys",
        "You don't have enough keys for this transaction",
        "failed",
      ]);
      return;
    }
    const result = await transaction(
      user.user_id,
      user.legal_first_name,
      user.legal_last_name,
      user.email_address,
      option,
      numValue,
    );
    if (result.success) {
      setAlert([
        "Request Sent",
        `Your request to ${option.toLowerCase()} ${numValue} keys has been sent to the admin for approval. You will be contacted for payment details.`,
        "confirm",
      ]);
      setValue(null);
      setOption(null);
    } else {
      setAlert([
        "Request Failed",
        result.error || "Something went wrong. Please try again.",
        "failed",
      ]);
    }
  };
  const purchaseAd = () => {
    if (advertisement && user) {
      adverisementRequest(
        user.user_id,
        "/" + uploadedItems[uploadedItems.length - 1],
        advertisement,
        user.email_address,
        "Banner",
      );
    }
  };
  useEffect(() => {
    purchaseAd();
  }, [uploadedItems]);
  return (
    <>
      <div className="w-[100%] tablet:w-[80%] mx-auto border-2  rounded-10 p-4 py-24 flex flex-col gap-12 my-36">
        <div className="w-[100%] tablet:w-[70%] mx-auto">
          <h1 className="font-bold text-52 text-center">Store</h1>
          <p className="text-center">500 keys are currently $1</p>
          {user ? (
            <h1 className="text-center text-30">
              You have a current key balance of {user.key_balance ?? 0}
            </h1>
          ) : (
            <h1 className="text-center text-30">
              You must log in to access store
            </h1>
          )}
          <div className="flex justify-evenly mt-4">
            <button
              className="bg-black text-white w-[140px] py-2 rounded-10"
              onClick={() => setOption("Buy")}
            >
              Buy
            </button>
            <button
              className="bg-black text-white w-[140px] py-2 rounded-10"
              onClick={() => setOption("Sell")}
            >
              Sell
            </button>
            <button
              className="bg-black text-white w-[140px] py-2 rounded-10"
              onClick={() => setOption("Stake")}
            >
              Stake
            </button>
          </div>
          {user && option === "Buy" ? (
            <div className="mt-8">
              <h1>BUY</h1>
              <hr />
              <div className="flex flex-col gap-2 my-8">
                <label>How many keys would you like to purchase?</label>
                <input
                  type="number"
                  min="1"
                  className="bg-slate-300 px-2 py-2"
                  value={value || ""}
                  onChange={(e) => setValue(e.target.value)}
                />
                <p className="text-xs text-gray-500">
                  Your request will be sent to the admin. You will be contacted
                  for payment.
                </p>
                <button
                  className="bg-black text-white w-[140px] py-2 rounded-10 mx-auto mt-4 px-4"
                  onClick={() => handleTransaction()}
                >
                  Request Keys
                </button>
              </div>
              <hr />
            </div>
          ) : (
            ""
          )}
          {user && option === "Sell" ? (
            <div className="mt-8">
              <h1>SELL</h1>
              <hr />
              <div className="flex flex-col gap-2 my-8">
                <label>How many keys would you like to sell?</label>
                <input
                  type="number"
                  min="1"
                  max={user.key_balance || 0}
                  className="bg-slate-300 px-2 py-2"
                  value={value || ""}
                  onChange={(e) => setValue(e.target.value)}
                />
                <p className="text-xs text-gray-500">
                  You can sell up to {user.key_balance ?? 0} keys.
                </p>
                <button
                  className="bg-black text-white w-[140px] py-2 rounded-10 mx-auto mt-4 px-4"
                  onClick={() => handleTransaction()}
                >
                  Sell Keys
                </button>
              </div>
              <hr />
            </div>
          ) : (
            ""
          )}
          {user && option === "Stake" ? (
            <div className="mt-8">
              <h1>STAKE</h1>
              <hr />
              <div className="flex flex-col gap-2 my-8">
                <label>How many keys would you like to stake?</label>
                <input
                  type="number"
                  min="1"
                  max={user.key_balance || 0}
                  className="bg-slate-300 px-2 py-2"
                  value={value || ""}
                  onChange={(e) => setValue(e.target.value)}
                />
                <p className="text-xs text-gray-500">
                  You can stake up to {user.key_balance ?? 0} keys.
                </p>
                <button
                  className="bg-black text-white w-[140px] py-2 rounded-10 mx-auto mt-4 px-4"
                  onClick={() => handleTransaction()}
                >
                  Stake Keys
                </button>
              </div>
              <hr />
            </div>
          ) : (
            ""
          )}
          <h1 className="text-30 text-center mt-4">Spend your keys</h1>
          <hr />
          <p className="text-center mt-8">
            Request to upload advertisement that will display globally on
            website.
          </p>

          {/* Advertisement eligibility check */}
          {user?.class_type === "Realtor" || user?.class_type === "Builder" ? (
            <>
              <p className="text-center text-sm text-green-600 font-semibold mt-4 mb-4">
                ✓ You are eligible to advertise as a {user?.class_type}
              </p>
              <div className="flex justify-center gap-6 items-center mt-8">
                <div className="flex flex-col justify-center items-center mt-12">
                  <div className="border-2 h-[50px] w-full"></div>
                  <p>Horizontal Ad Space</p>
                  <input
                    className="w-[50px] h-[25px] hover:cursor-pointer"
                    checked={advertisement === "horizontal" ? true : false}
                    type="checkbox"
                    onChange={() => setAdvertisement("horizontal")}
                  />
                </div>
                <div className="flex flex-col justify-center items-center">
                  <div className="border-2 w-[50px] h-[100px]"></div>
                  <p>Vertical Ad Space</p>
                  <input
                    className="w-[50px] h-[25px] hover:cursor-pointer"
                    checked={advertisement === "vertical" ? true : false}
                    type="checkbox"
                    onChange={() => setAdvertisement("vertical")}
                  />
                </div>
              </div>
              <div className="flex justify-center mt-4">
                <button
                  className="text-white bg-black px-2 py-2 rounded-10"
                  onClick={() => setModal(true)}
                >
                  Purchase Advertisement Space
                </button>
              </div>
            </>
          ) : (
            <div className="bg-yellow-50 border-2 border-yellow-300 rounded-lg p-4 mt-4 mb-4">
              <p className="text-sm font-semibold text-yellow-800 mb-2">
                ℹ Advertisement Access Limited
              </p>
              <p className="text-sm text-yellow-700">
                Currently, only Real Estate Sales Agents and Builder Sales
                Agents can create global advertisements.
              </p>
              <p className="text-sm text-yellow-700 mt-2">
                If you represent a Title Company, Lender, or other service,
                please{" "}
                <button
                  onClick={() => setReportModalOpen(true)}
                  className="font-semibold text-yellow-800 hover:underline cursor-pointer bg-transparent border-none p-0"
                >
                  report this issue
                </button>{" "}
                to request advertisement placement.
              </p>
            </div>
          )}
          <div className="mt-12">
            <p className="text-center">
              Have your profile promoted on all property listing pages with
              format:
            </p>
            <Promote />
            <div className="flex justify-center mt-4">
              <button
                className="text-white bg-black px-2 py-2 rounded-10 hover:cursor-pointer"
                onClick={() => setPromotion(true)}
              >
                Purchase Profile Promotion
              </button>
            </div>
          </div>
        </div>
      </div>
      {promotion && (
        <>
          <div className="top-0 left-0 bg-black/60 w-screen h-screen fixed"></div>
          <div className="p-4 absolute top-0 flex w-full left-0 justify-center items-center h-full">
            <div className="p-4 bg-white w-[40%] text-center relative">
              <h1>Profile Promotion</h1>
              <AiFillCloseCircle
                className="absolute right-4 top-2 hover:scale-105 hover:cursor-pointer"
                size={30}
                onClick={() => setPromotion(false)}
              />
              <hr />
              <p className="text-xs mt-4">
                Promotion will reflect on all property pages after request is
                accepted.
              </p>
              <p className="text-red-500 text-xs">
                Your promotion will be active for 7500 impressions, or until the
                promotional slots are filled past yours.
              </p>
              <p className="text-red-500 text-xs">
                Your keys will be deducted only if promotion is accepted.
              </p>

              {user ? (
                <button
                  className="px-4 py-2 bg-black rounded-10 text-white mt-4"
                  onClick={() => purchasePromotion()}
                >
                  Confirm Profile Purchase
                </button>
              ) : (
                <p>You must log in</p>
              )}
            </div>
          </div>
        </>
      )}
      {modal && (
        <>
          <div className="top-0 left-0 bg-black/60 w-screen h-screen fixed"></div>
          <div className="p-4 absolute top-0 flex w-full left-0 justify-center items-center h-full">
            <div className="p-4 bg-white w-[40%] text-center relative">
              <h1>Upload advertisement</h1>
              <AiFillCloseCircle
                className="absolute right-4 top-2 hover:scale-105 hover:cursor-pointer"
                size={30}
                onClick={() => setModal(false)}
              />
              <hr />
              <p className="text-xs mt-4">
                Please make sure selected orientation for advertisement matches
                uploaded.
                <br />
                If there are conflicting issues with the dimensions of the ad,
                you will be contacted for an updated advertisement.
              </p>
              <p className="text-red-500 text-xs">
                The recommended dimensions for advertisements are: Horizontal -
                793px x 150px Vertical - 348px x 669px{" "}
              </p>
              <p className="text-red-500 text-xs mt-4">
                Upon uploading an image your request for an advertisement will
                be sent. You can not edit or delete this request after.
              </p>
              {user ? (
                <UploadAdvertisement
                  setUploadedItems={setUploadedItems}
                  setModal={setModal}
                />
              ) : (
                <p>You must log in</p>
              )}
              <p>
                You will be able to upload one photo and the prompt will close,
                you will get confirmation if your request was sent.
              </p>
            </div>
          </div>
        </>
      )}
      <ReportModal
        isOpen={reportModalOpen}
        onClose={() => setReportModalOpen(false)}
      />
    </>
  );
};

export default Store;
